import React, { useState, useRef } from 'react';

import Link from 'next/link';
import { skillCategory } from 'constants/skills-category.const';
import { useSelector } from 'react-redux';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';

import Modal from '@core/components/Modal/Modal';
import RadarChart from '@core/components/radarchart/RadarChart';
import ShadowBox from '@core/components/shadowbox/ShadowBox';
import LinkButton from '@core/components/linkbutton/LinkButton';
import SkillCategoryCourses from './skillcategorycourses/SkillCategoryCourses';
import PremiumFeatureModal from '@core/components/premiumfeaturemodal/PremiumFeatureModal';
import ActionButton from '@core/components/actionbutton/ActionButton';
import ContinueCourses from 'components/pages/userdashboard/userdashboardinfo/continuecourses/ContinueCourses';
import FreeCourseLimitation from './freecourselimitation/FreeCourseLimitation';

import JobCompletedIconIcon from 'assets/icons/teacher-blue.svg';
import RadarIcon from 'assets/icons/radar-2.svg';
import { InfoCircle, Book1, Teacher, TrendUp } from 'iconsax-react';

import classes from './UserDashboardInfo.module.scss';






const UserDashboardInfo = ({ data }) => {
    const hasSubscription = useSelector(state => state.user.hasSubscription);
    const coursesRef = useRef();
    const { ToastContainer, toast } = UseToast();
    const { show: showGoPremium, showModal: showGoPremiumModal, destroyModal: destroyGoPremiumModal } = UseModal();

    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedIndexHandler = (index) => {
        // if (hasSubscription) {
        setSelectedIndex(index);
        setTimeout(() => {
            const topOffset = coursesRef.current.getBoundingClientRect().top + window.scrollY;
            console.log(topOffset)
            window.scrollTo({
                top: topOffset - 100,
                behavior: "smooth",
            });
        }, 300);

        // }

        // else
        //     showGoPremiumModal();
    };
    return (
        <>
            <ToastContainer />
            <div className={`${classes.wrapper} container p-lg-0 mb-5`}>
                <div className="row">
                    <div className="col-lg-7 col-12 pe-lg-1 ">
                        <div className={classes['new-course-wrapper']}>
                            <div>
                                <span>{data?.campaign?.title}</span>
                                <h3>{data?.campaign?.text}</h3>
                            </div>
                            <LinkButton href={data?.campaign?.link}>
                                {data?.campaign?.button_text}
                            </LinkButton>
                        </div>
                    </div>
                    <div className="col-lg-5 col-12 mt-lg-0 mt-3">
                        <div className={classes['progress-wrapper']}>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h5>
                                    Your Progress
                                </h5>
                                <LinkButton kind='simple' to={'/my-skill-tree'}>
                                    Learn More
                                </LinkButton>
                            </div>
                            <Link href="/my-skill-tree" underline="none">
                                <div className={classes['chart-wrapper']}>
                                    <RadarChart
                                        chartData={data.skill_tree}
                                        selectedIndex={selectedIndex}
                                        selectedIndexHandler={selectedIndexHandler}
                                        isSmall={true}
                                    />
                                </div>
                            </Link>

                        </div>
                    </div>
                </div>
                {data?.next_free_lecture_unlocks_in && (
                    <FreeCourseLimitation time={data?.next_free_lecture_unlocks_in} />
                )}

                <div className={`${classes['user-statics']} row d-flex`}>
                    <div className="col-md-4 col-12 pe-md-1 ">
                        <LinkButton to={'/myuni'}>
                            <span className='d-xl-none d-xxl-block'>
                                <Book1 size={12} variant="TwoTone" />
                            </span>
                            <h5> In-progress Courses <div>{data?.progressing_contents_count}</div>  </h5>

                        </LinkButton>
                    </div>
                    <div className="col-md-4 col-12 px-md-1 mt-md-0 mt-2 ">
                        <LinkButton to={'/myuni'}>
                            <span className={`d-xl-none d-xxl-block ${classes['teacher-icon']}`}>
                                <Teacher size={12} variant="TwoTone" />
                            </span>
                            <h5> Completed Courses <div>{data?.completed_lectures_count}</div>  </h5>

                        </LinkButton>
                    </div>
                    <div className="col-md-4 col-12 ps-md-1 mt-md-0 mt-2 ">
                        <LinkButton to={'/my-career-path'}>
                            <span className={`d-xl-none d-xxl-block ${classes['trend-icon']}`}>
                                <TrendUp size={12} variant="TwoTone" />
                            </span>
                            <h5> Enrolled Path <div>{data?.enrolled_career_paths_count}</div> </h5>
                        </LinkButton>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-12'>
                        <h4>Continue Learning</h4>
                        <div className={classes['coutinue-learning-wrapper']}>
                            <div className='d-flex justify-content-end mb-3'>
                                <LinkButton kind='simple' to={'/myuni'} >
                                    View all in-progress courses
                                </LinkButton>
                            </div>
                            <ContinueCourses data={data.progressing_lectures} />
                        </div>
                        <div className={classes['vip-wrapper']}>
                            <div className='row'>
                                <div className='col-md-2 col-12'></div>
                                <div className='col-md-7 col-12'>
                                    <div className='ps-md-4'>
                                        <h5>
                                            Don't Miss Your VIP Coaching Session!
                                        </h5>
                                        <p>
                                            Your exclusive 1:1 coaching session is waiting! Stay on
                                            track with your career goals—schedule
                                            or join your session now and make the most of your VIP access.
                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-3 col-12 ps-0 d-flex align-items-center justify-content-center'>
                                    <LinkButton kind='secondary-light' to={'/vip-consultation'} >Schedule Free Session</LinkButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <Modal
                type={MOBILE_SLIDE_UP}
                show={showGoPremium}
                closeHandler={destroyGoPremiumModal}
                header={false}
                isGoPermium={true}
            >
                <PremiumFeatureModal closeHandler={destroyGoPremiumModal} featureName={'skill'} />
            </Modal>
        </>

    );
};

export default UserDashboardInfo;